import { render, staticRenderFns } from "./review.vue?vue&type=template&id=26f1cffc&scoped=true&"
import script from "./review.vue?vue&type=script&lang=js&"
export * from "./review.vue?vue&type=script&lang=js&"
import style0 from "./review.vue?vue&type=style&index=0&id=26f1cffc&prod&scoped=true&lang=css&"
import style1 from "./review.vue?vue&type=style&index=1&id=26f1cffc&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f1cffc",
  null
  
)

export default component.exports